import { Maybe } from 'maybe-not';
import { TestingWindow } from 'q2-tecton-common/lib/utility/message-bus';

export default function loadDefaultTheme(cdnOverride?: () => Promise<string>): Promise<void> {
    const cdnOverridePromise: Promise<Maybe<string>> = cdnOverride
        ? cdnOverride().then(Maybe.maybe)
        : Promise.resolve(Maybe.nothing<string>());

    return cdnOverridePromise.then(maybeCdnOverrideUrl => {
        const defaultThemePath = getDefaultThemePath(
            maybeCdnOverrideUrl,
            TECTONSDKVERSION,
            TECTON_SDK_BUILD_MODE === 'none',
            TECTON_SDK_BUILD_MODE === 'development'
        );
        return insertDefaultThemeTag(defaultThemePath);
    });
}

export function getDefaultThemePath(
    maybeCdnUrl: Maybe<string>,
    tectonVersion: string,
    isLocalDevelopment: boolean,
    isDevelopmentBuild = false
): string {
    // // build local should have different url for theme
    if (isLocalDevelopment) {
        return 'http://localhost:2020/q2-tecton-theme.css';
    } else if (isDevelopmentBuild) {
        return 'http://devcdn/cdn/base/tecton/develop/q2-tecton-theme.css';
    }

    return `${maybeCdnUrl.withDefault(
        'https://cdn1.onlineaccess1.com/cdn/base/'
    )}tecton/v${tectonVersion}/q2-tecton-theme.css`;
}

export function insertDefaultThemeTag(themePath: string): Promise<void> {
    // insert default theme tag above other tags if present
    return new Promise(function(resolve, reject) {
        const defaultThemeLinkTag = document.createElement('link');
        defaultThemeLinkTag.rel = 'stylesheet';
        defaultThemeLinkTag.href = themePath;
        defaultThemeLinkTag.id = 'tecton-default-theme';
        defaultThemeLinkTag.onload = () => {
            resolve();
        };

        const headNode = document.querySelector('head')!;

        const firstStyleOrLinkTag = headNode.querySelectorAll('link, style')[0];

        try {
            headNode.insertBefore(defaultThemeLinkTag, firstStyleOrLinkTag);
        } catch (e) {
            if ((window as TestingWindow).isTestingTecton) {
                resolve();
            } else {
                reject();
            }
        }

        if ((window as TestingWindow).isTestingTecton) {
            resolve();
        }
    });
}
